import * as React from 'react';
import { BranchingAndLayout } from '../../components/pages/logic-and-layout/BranchingAndLayout';
import { SurveyStep } from '../../models';
import { SurveyPageStateSetter } from '../state-setter/SurveyPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const BranchingAndLayoutPage = (props: PageStateSetterRouteProps) => {
	return (
		<>
			<BranchingAndLayout />
			<SurveyPageStateSetter {...props} currentStep={SurveyStep.LogicAndLayout} />
		</>
	);
};
